import { __extends } from "tslib";
import { RendererBase } from './RendererBase';
/**
 * The DepthRenderer class renders 32-bit depth information encoded as RGBA
 *
 * @class away.render.DepthRenderer
 */
var DepthRenderer = /** @class */ (function (_super) {
    __extends(DepthRenderer, _super);
    /**
     * Creates a new DepthRenderer object.
     * @param renderBlended Indicates whether semi-transparent objects should be rendered.
     * @param distanceBased Indicates whether the written depth value is distance-based or projected depth-based
     */
    function DepthRenderer(partition, pool) {
        return _super.call(this, partition, pool) || this;
    }
    /**
     *
     */
    DepthRenderer.prototype.enterNode = function (node) {
        var enter = node._collectionMark != RendererBase._collectionMark && node.isCastingShadow();
        if (!enter) {
            node._collectionMark = RendererBase._collectionMark;
            return false;
        }
        return _super.prototype.enterNode.call(this, node);
    };
    DepthRenderer.registerMaterial = function (renderMaterialClass, materialClass) {
        DepthRenderer.materialClassPool[materialClass.assetType] = renderMaterialClass;
    };
    DepthRenderer.materialClassPool = {};
    DepthRenderer.renderGroupPool = {};
    DepthRenderer.defaultBackground = 0x0;
    return DepthRenderer;
}(RendererBase));
export { DepthRenderer };
